import { DatePicker as CommonDatePicker } from "@WealthierAI/core";

interface DatePickerProps {
  name: string;
  label: string;
  value: string;
  onChange: (data: string) => void;
  dateRestriction?: "past" | "future" | "none";
  requireAdult?: boolean;
  modalMode?: boolean;
}

const DatePicker: React.FC<DatePickerProps> = ({
  name,
  label,
  value,
  onChange,
  dateRestriction = "none",
  requireAdult = false,
  modalMode = false,
}) => {
  const getMaxDate = (): string | undefined => {
    if (dateRestriction === "past") {
      if (requireAdult) {
        // Calculate date 18 years ago
        const today = new Date();
        const eighteenYearsAgo = new Date(
          today.getFullYear() - 18,
          today.getMonth(),
          today.getDate()
        );
        return eighteenYearsAgo.toISOString().split("T")[0];
      } else {
        // today
        return new Date().toISOString().split("T")[0];
      }
    }
    return undefined;
  };

  const getMinDate = (): string | undefined => {
    if (dateRestriction === "future") {
      return new Date().toISOString().split("T")[0];
    }
    return undefined;
  };

  return (
    <div className="mt-4">
      <CommonDatePicker
        minDate={getMinDate()}
        maxDate={getMaxDate()}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        modalMode={modalMode}
      />
    </div>
  );
};

export default DatePicker;
